import axios from "axios"

function getStudents() {
    return axios.get("/api/students")
}

function getStudent({ id }, data, params) {
    return axios.get(`api/students/${id}`, { params })
}

function studentSurvey() {
    return axios.get("/api/student-survey")
}

function studentChangePaymentCollectionDay({}, data) {
    return axios.put(
        `/api/v2/subscribe/student-change-payment-collection-day`,
        data
    )
}

function addStudentSurvey(value) {
    return axios.post(`api/student-survey`, { ...value })
}

function generateProfileImage({ id }, data) {
    return axios.post(`api/v1/students/${id}/generate-profile-image`, data)
}

function getProfileImageStatus({ id }) {
    return axios.get(`api/v1/students/${id}/profile-image-status`)
}

export const studentsService = {
    getStudents,
    getStudent,
    studentSurvey,
    addStudentSurvey,
    studentChangePaymentCollectionDay,
    generateProfileImage,
    getProfileImageStatus,
}
